// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__2UZJ7","filesListContainer":"PosDisputesFiles_filesListContainer__1VeQA","filesButton":"PosDisputesFiles_filesButton__3n1V9"};